import {AppLocalStorage} from "@services/utils";

export const updateUser = (state, opened) => {
  state.user = opened
  AppLocalStorage.setItem('taxiAuth.user', JSON.stringify(state.user));
}
export const removeUser = (state) => {
  state.user = null
  AppLocalStorage.removeItem('taxiAuth.user');
}
export const updateToken = (state, opened) => {
  const now = new Date();
  const expireTime = now.setTime(now.getTime() + Number(opened.expire_time))
  state.token = opened.token
  state.expire_time = expireTime
  AppLocalStorage.setItem('taxiAuth.token', state.token);
  AppLocalStorage.setItem('taxiAuth.expire_time', String(expireTime));
}
export const removeToken = (state) => {
  state.token = null
  state.expire_time = null
  AppLocalStorage.removeItem('taxiAuth.token');
  AppLocalStorage.removeItem('taxiAuth.expire_time');
}
